import {
	createApp
} from 'vue'
import App from './App.vue'
import router from './router'

import eIconPicker from 'e-icon-picker';
import "e-icon-picker/lib/symbol.js"; //基本彩色图标库
import 'e-icon-picker/lib/index.css'; // 基本样式，包含基本图标
import 'font-awesome/css/font-awesome.min.css'; //font-awesome 图标库

import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import store from './store'
import "./assets/scss/normalize.scss"
import 'element-plus/dist/index.css'
import "./assets/scss/elementcustom.scss"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import dayjs from "dayjs"

const app = createApp(App)
app.config.globalProperties.$dayjs = dayjs
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
	app.component(key, component)
}
NProgress.configure({
	easing: 'ease', // 动画方式
	speed: 600, // 递增进度条的速度
	showSpinner: true, // 是否显示加载ico
	trickleSpeed: 200, // 自动递增间隔
	minimum: 0.3 // 初始化时的最小百分比
})

router.beforeEach((to, from, next) => {
	NProgress.start();
	next();
});
router.afterEach(() => { // 在即将进入新的页面组件前，关闭掉进度条
	NProgress.done()
})

// 页面转PDF
import htmlToPdf from './utils/htmlToPdf.js'
// 使用Vue.use()方法就会调用工具方法中的install方法

app.use(router).use(store).use(ElementPlus, {
	locale: zhCn,
  }).use(eIconPicker, {
    FontAwesome: true,
    ElementUI: true,
    eIcon: true,//自带的图标，来自阿里妈妈
    eIconSymbol: true,//是否开启彩色图标
    addIconList: [],
    removeIconList: [],
    zIndex: 3100//选择器弹层的最低层,全局配置
}).use(htmlToPdf).mount('#app')
